import { render } from "./AboutCookies.vue?vue&type=template&id=0d4184e6"
import script from "./AboutCookies.vue?vue&type=script&lang=js"
export * from "./AboutCookies.vue?vue&type=script&lang=js"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__